import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import CommonModal from '@/components-latest/shared/Modals/CommonModal'
import ProductStatsCard from '@/components-latest/ui/PerformancePage/ProductStatsCard'
import { BestSellingDetails } from '@/ducks/performance/performance.types'

import Styles from './BestSellingModal.module.scss'

interface IBestSellingModalProps {
  open: boolean
  onOpenChange: (isOpen: boolean) => void
  bestSellingItems: BestSellingDetails[]
  title: string
}

const BestSellingModal: React.FC<IBestSellingModalProps> = ({
  bestSellingItems,
  ...modalProps
}) => {
  const { t } = useTranslation()

  const footer = (
    <div>
      <Button
        variant="tertiary"
        size="medium"
        onClick={() => modalProps.onOpenChange(false)}>
        {t('common.modal.close')}
      </Button>
    </div>
  )

  const body = (
    <div className={Styles.bestSellingBody}>
      <div className={Styles.bestSellingList}>
        {bestSellingItems.map(review => (
          <ProductStatsCard key={review.item_id} {...review} />
        ))}
      </div>
    </div>
  )

  return (
    <CommonModal
      {...modalProps}
      body={body}
      footer={footer}
      width={448}
      withFooterSeparator
      withoutCloseIcon
      scrollableBody
    />
  )
}

export type { IBestSellingModalProps }
export default BestSellingModal
